
import { UseFormRegister, FieldErrors, UseFormWatch } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface WorkPermitSectionProps {
  register: UseFormRegister<any>;
  errors: FieldErrors;
  setValue: (name: string, value: any) => void;
  watch: UseFormWatch<any>;
}

export function WorkPermitSection({ register, errors, setValue, watch }: WorkPermitSectionProps) {
  const nationality = watch("nationality");
  const isNonSwiss = nationality && nationality !== "Swiss";

  if (!isNonSwiss) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Arbeitsbewilligung</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Bewilligungstyp</Label>
            <Select onValueChange={(value) => setValue("work_permit_type", value)}>
              <SelectTrigger>
                <SelectValue placeholder="Typ wählen..." />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="B">B-Bewilligung (Aufenthaltsbewilligung)</SelectItem>
                <SelectItem value="C">C-Bewilligung (Niederlassungsbewilligung)</SelectItem>
                <SelectItem value="G">G-Bewilligung (Grenzgängerbewilligung)</SelectItem>
                <SelectItem value="L">L-Bewilligung (Kurzaufenthaltsbewilligung)</SelectItem>
              </SelectContent>
            </Select>
          </div>
          
          <div className="space-y-2">
            <Label>Bewilligung gültig bis</Label>
            <Input 
              type="date"
              {...register("work_permit_expires")} 
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
